import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from './ConditionSerialization.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Always_getInstancecs10mhg5aot2 as Always_getInstance } from './Condition.mjs';
import { DataClassPathSerializer1pr4zwqha0dv8 as DataClassPathSerializer } from '../serialization/DataClassPathSerializer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Companion_getInstancetl9eamf8zl9j as Companion_getInstance } from './Aggregate.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.GroupCountQuery', null, 2);
        tmp0_serialDesc.a1b('condition', true);
        tmp0_serialDesc.a1b('groupBy', false);
        this.d3l_1 = tmp0_serialDesc;
      }
      q2j(typeSerial0) {
        return $serializer().g3z(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.q2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static h3z() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.GroupCountQuery', $this, 2);
        tmp0_serialDesc.a1b('condition', true);
        tmp0_serialDesc.a1b('groupBy', false);
        $this.e3z_1 = tmp0_serialDesc;
        return $this;
      }
      i3z(encoder, value) {
        var tmp0_desc = this.e3z_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.j3z_1.equals(Always_getInstance())) {
          tmp1_output.c15(tmp0_desc, 0, new (ConditionSerializer())(this.f3z_1), value.j3z_1);
        }
        tmp1_output.c15(tmp0_desc, 1, new (DataClassPathSerializer())(this.f3z_1), value.k3z_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i3z(encoder, value instanceof GroupCountQuery() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e3z_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.f3z_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (DataClassPathSerializer())(this.f3z_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.f3z_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (DataClassPathSerializer())(this.f3z_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return GroupCountQuery().l3z(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.e3z_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.f3z_1), new (DataClassPathSerializer())(this.f3z_1)];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.f3z_1];
      }
      static g3z(typeSerial0) {
        var $this = this.h3z();
        $this.f3z_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var GroupCountQueryClass;
function GroupCountQuery() {
  if (GroupCountQueryClass === VOID) {
    class $ {
      toString() {
        return 'GroupCountQuery(condition=' + toString(this.j3z_1) + ', groupBy=' + this.k3z_1.toString() + ')';
      }
      hashCode() {
        var result = this.j3z_1.hashCode();
        result = imul(result, 31) + this.k3z_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GroupCountQuery()))
          return false;
        if (!this.j3z_1.equals(other.j3z_1))
          return false;
        if (!this.k3z_1.equals(other.k3z_1))
          return false;
        return true;
      }
      static l3z(seen0, condition, groupBy, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, Companion_getInstance_0().d3l_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.j3z_1 = Always_getInstance();
        else
          $this.j3z_1 = condition;
        $this.k3z_1 = groupBy;
        return $this;
      }
    }
    initMetadataForClass($, 'GroupCountQuery', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    GroupCountQueryClass = $;
  }
  return GroupCountQueryClass;
}
function AggregateQuery$Companion$$childSerializers$_anonymous__mdtkin() {
  return Companion_getInstance().k2a();
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.e3l_1 = [lazy(tmp_0, AggregateQuery$Companion$$childSerializers$_anonymous__mdtkin), null, null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.AggregateQuery', null, 3);
        tmp0_serialDesc.a1b('aggregate', false);
        tmp0_serialDesc.a1b('condition', true);
        tmp0_serialDesc.a1b('property', false);
        this.f3l_1 = tmp0_serialDesc;
      }
      q2j(typeSerial0) {
        return $serializer_0().o3z(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.q2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      static p3z() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.AggregateQuery', $this, 3);
        tmp0_serialDesc.a1b('aggregate', false);
        tmp0_serialDesc.a1b('condition', true);
        tmp0_serialDesc.a1b('property', false);
        $this.m3z_1 = tmp0_serialDesc;
        return $this;
      }
      q3z(encoder, value) {
        var tmp0_desc = this.m3z_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().e3l_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.r3z_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !value.s3z_1.equals(Always_getInstance())) {
          tmp1_output.c15(tmp0_desc, 1, new (ConditionSerializer())(this.n3z_1), value.s3z_1);
        }
        tmp1_output.c15(tmp0_desc, 2, new (DataClassPathSerializer())(this.n3z_1), value.t3z_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.q3z(encoder, value instanceof AggregateQuery() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.m3z_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_1().e3l_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.n3z_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, new (DataClassPathSerializer())(this.n3z_1), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.n3z_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, new (DataClassPathSerializer())(this.n3z_1), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return AggregateQuery().u3z(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.m3z_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_1().e3l_1[0].f2(), new (ConditionSerializer())(this.n3z_1), new (DataClassPathSerializer())(this.n3z_1)];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.n3z_1];
      }
      static o3z(typeSerial0) {
        var $this = this.p3z();
        $this.n3z_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var AggregateQueryClass;
function AggregateQuery() {
  if (AggregateQueryClass === VOID) {
    class $ {
      constructor(aggregate, condition, property) {
        Companion_getInstance_1();
        condition = condition === VOID ? Always_getInstance() : condition;
        this.r3z_1 = aggregate;
        this.s3z_1 = condition;
        this.t3z_1 = property;
      }
      toString() {
        return 'AggregateQuery(aggregate=' + this.r3z_1.toString() + ', condition=' + toString(this.s3z_1) + ', property=' + this.t3z_1.toString() + ')';
      }
      hashCode() {
        var result = this.r3z_1.hashCode();
        result = imul(result, 31) + this.s3z_1.hashCode() | 0;
        result = imul(result, 31) + this.t3z_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AggregateQuery()))
          return false;
        if (!this.r3z_1.equals(other.r3z_1))
          return false;
        if (!this.s3z_1.equals(other.s3z_1))
          return false;
        if (!this.t3z_1.equals(other.t3z_1))
          return false;
        return true;
      }
      static u3z(seen0, aggregate, condition, property, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(5 === (5 & seen0))) {
          throwMissingFieldException(seen0, 5, Companion_getInstance_1().f3l_1);
        }
        var $this = createThis(this);
        $this.r3z_1 = aggregate;
        if (0 === (seen0 & 2))
          $this.s3z_1 = Always_getInstance();
        else
          $this.s3z_1 = condition;
        $this.t3z_1 = property;
        return $this;
      }
    }
    initMetadataForClass($, 'AggregateQuery', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    AggregateQueryClass = $;
  }
  return AggregateQueryClass;
}
function GroupAggregateQuery$Companion$$childSerializers$_anonymous__px3v0i() {
  return Companion_getInstance().k2a();
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g3l_1 = [lazy(tmp_0, GroupAggregateQuery$Companion$$childSerializers$_anonymous__px3v0i), null, null, null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.GroupAggregateQuery', null, 4);
        tmp0_serialDesc.a1b('aggregate', false);
        tmp0_serialDesc.a1b('condition', true);
        tmp0_serialDesc.a1b('groupBy', false);
        tmp0_serialDesc.a1b('property', false);
        this.h3l_1 = tmp0_serialDesc;
      }
      q2j(typeSerial0) {
        return $serializer_1().x3z(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.q2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      static y3z() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.GroupAggregateQuery', $this, 4);
        tmp0_serialDesc.a1b('aggregate', false);
        tmp0_serialDesc.a1b('condition', true);
        tmp0_serialDesc.a1b('groupBy', false);
        tmp0_serialDesc.a1b('property', false);
        $this.v3z_1 = tmp0_serialDesc;
        return $this;
      }
      z3z(encoder, value) {
        var tmp0_desc = this.v3z_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().g3l_1;
        tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.a40_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !value.b40_1.equals(Always_getInstance())) {
          tmp1_output.c15(tmp0_desc, 1, new (ConditionSerializer())(this.w3z_1), value.b40_1);
        }
        tmp1_output.c15(tmp0_desc, 2, new (DataClassPathSerializer())(this.w3z_1), value.c40_1);
        tmp1_output.c15(tmp0_desc, 3, new (DataClassPathSerializer())(this.w3z_1), value.d40_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z3z(encoder, value instanceof GroupAggregateQuery() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.v3z_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        var tmp9_cached = Companion_getInstance_2().g3l_1;
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.w3z_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, new (DataClassPathSerializer())(this.w3z_1), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.x13(tmp0_desc, 3, new (DataClassPathSerializer())(this.w3z_1), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.x13(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.w3z_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.x13(tmp0_desc, 2, new (DataClassPathSerializer())(this.w3z_1), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.x13(tmp0_desc, 3, new (DataClassPathSerializer())(this.w3z_1), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return GroupAggregateQuery().e40(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.v3z_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_2().g3l_1[0].f2(), new (ConditionSerializer())(this.w3z_1), new (DataClassPathSerializer())(this.w3z_1), new (DataClassPathSerializer())(this.w3z_1)];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.w3z_1];
      }
      static x3z(typeSerial0) {
        var $this = this.y3z();
        $this.w3z_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var GroupAggregateQueryClass;
function GroupAggregateQuery() {
  if (GroupAggregateQueryClass === VOID) {
    class $ {
      toString() {
        return 'GroupAggregateQuery(aggregate=' + this.a40_1.toString() + ', condition=' + toString(this.b40_1) + ', groupBy=' + this.c40_1.toString() + ', property=' + this.d40_1.toString() + ')';
      }
      hashCode() {
        var result = this.a40_1.hashCode();
        result = imul(result, 31) + this.b40_1.hashCode() | 0;
        result = imul(result, 31) + this.c40_1.hashCode() | 0;
        result = imul(result, 31) + this.d40_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GroupAggregateQuery()))
          return false;
        if (!this.a40_1.equals(other.a40_1))
          return false;
        if (!this.b40_1.equals(other.b40_1))
          return false;
        if (!this.c40_1.equals(other.c40_1))
          return false;
        if (!this.d40_1.equals(other.d40_1))
          return false;
        return true;
      }
      static e40(seen0, aggregate, condition, groupBy, property, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(13 === (13 & seen0))) {
          throwMissingFieldException(seen0, 13, Companion_getInstance_2().h3l_1);
        }
        var $this = createThis(this);
        $this.a40_1 = aggregate;
        if (0 === (seen0 & 2))
          $this.b40_1 = Always_getInstance();
        else
          $this.b40_1 = condition;
        $this.c40_1 = groupBy;
        $this.d40_1 = property;
        return $this;
      }
    }
    initMetadataForClass($, 'GroupAggregateQuery', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    GroupAggregateQueryClass = $;
  }
  return GroupAggregateQueryClass;
}
//region block: exports
export {
  AggregateQuery as AggregateQuery2zg9ab3akfubi,
  Companion_getInstance_1 as Companion_getInstance2me4dixbj0lj0,
  Companion_getInstance_2 as Companion_getInstance2r8wjyblz0idz,
  Companion_getInstance_0 as Companion_getInstance1khfkwo5dix9p,
};
//endregion

//# sourceMappingURL=GroupCountQuery.mjs.map
